/* eslint @typescript-eslint/camelcase: 0 */
import { request } from "api";

export type IndexResponse = {
  id: number;
  name: string;
  developer: {
    id: number;
    name: string;
  };
  apps: {
    id: number;
    appGroup: number;
    os: string;
    appId: string;
    redDmpAppId: number;
    redUserId: number;
    isTver: boolean;
    twitterUserId: string;
    trackingVendor: {
      id: number;
      name: string;
    };
  }[];
  createdAt: string;
  updatedAt: string;
};

export class Api {
  public static index(agencyId: number) {
    return request.get<IndexResponse[]>(`/agencies/${agencyId}/app_groups`);
  }
}
